import { Button, Modal, TextInput } from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useAppDispatch, useAppSelector } from '../../Reducers/store';
import { EquipmentVideo } from '../../Models/EquipmentVideo';
import EquipmentApi from '../../Api/EquipmentApi';
import { fetchCustomOptions } from '../../Actions/CommonFields';

export default function AddEquipmentVideoModal({
  show,
  setShow,
  getEquipmentVideos,
  equipmentId,
  equipmentVideo,
}: {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  equipmentId: number;
  getEquipmentVideos: () => Promise<void> | undefined;
  equipmentVideo: EquipmentVideo | null;
}) {
  const dispatch = useAppDispatch();
  const { customOptions } = useAppSelector((state) => state.commonFields);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);

  const [formData, setFormData] = useState<EquipmentVideo>({
    id: 0,
    equipmentId: 0,
    videoUrl: null,
    dateAdded: null,
    caption: null,
    typeId: null,
    safeVideoURL: '',
  });

  const getReferences = async () => {
    if (!customOptions.length) {
      await Promise.all([dispatch(fetchCustomOptions())]);
    }
  };

  useEffect(() => {
    if (show === true) {
      getReferences();
    }
  }, [show]);

  const handleSetInitialValues = () => {
    const values = equipmentVideo
      ? {
          ...equipmentVideo,
        }
      : {
          id: 0,
          equipmentId: equipmentId,
          videoUrl: null,
          dateAdded: null,
          caption: null,
          typeId: null,
          safeVideoURL: '',
        };
    setFormData(values as EquipmentVideo);
  };

  useEffect(() => {
    handleSetInitialValues();
  }, [equipmentVideo]);

  const handleResetFormValues = () => {
    const values = {
      id: 0,
      equipmentId: 0,
      videoUrl: null,
      dateAdded: null,
      caption: null,
      typeId: null,
      safeVideoURL: '',
    };
    setFormData(values as EquipmentVideo);
  };

  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const onSubmit = async () => {
    setButtonDisabled(true);
    setIsLoading(true);
    await EquipmentApi.addUpdateEquipmentVideo(formData)
      .then((res) => {
        if (res.data.success) {
          setIsLoading(false);
          setButtonDisabled(false);
          toast.success('Save Success');
          handleResetFormValues();
          getEquipmentVideos();
          onCloseModal();
        } else {
          setIsLoading(false);
          setButtonDisabled(false);
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        toast.error('Error: ' + err);
        setIsLoading(false);
      });
  };

  function onCloseModal() {
    setShow(false);
  }

  return (
    <Modal show={show} size='4xl' onClose={onCloseModal} popup>
      <Modal.Header></Modal.Header>
      <Modal.Body>
        <div className='w-full'>
          <div className='w-full'>
            <div className='mx-1 flex items-end justify-center'>
              <div className='flex flex-1 justify-center'>
                <h1 className='text-gray-900 font-bold text-4xl'>Add Video</h1>
              </div>
            </div>
          </div>

          <div>
            <div className='container mx-auto p-2'>
              <div className='md:flex no-wrap md:-mx-2 '>
                <div className='w-full'>
                  <div className='bg-white'>
                    <div className='flex items-center space-x-2 font-bold text-gray-500 leading-8'>
                      <span className='tracking-wide uppercase text-3xl'>
                        Information
                      </span>
                    </div>
                    <hr className='bg-gray-300 h-[5px]'></hr>
                    <form>
                      <div className='text-gray-500'>
                        <hr className='bg-gray-300 h-[2px]'></hr>
                        <div className='grid grid-cols-[20%_80%] text-xl'>
                          <div className='flex'>
                            <div className='font-bold content-center'>URL:</div>
                          </div>
                          <div className='w-full'>
                            <TextInput
                              id='videoUrl'
                              name='videoUrl'
                              type='text'
                              onChange={handleChangeInput}
                              value={formData.videoUrl ?? ''}
                              sizing='md'
                            />
                          </div>
                        </div>
                        <hr className='bg-gray-300 h-[2px]'></hr>
                        <div className='grid grid-cols-[20%_80%] text-xl'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Caption:
                            </div>
                          </div>
                          <div className='w-full'>
                            <TextInput
                              id='caption'
                              name='caption'
                              type='text'
                              onChange={handleChangeInput}
                              value={formData.caption ?? ''}
                              sizing='md'
                            />
                          </div>
                        </div>
                      </div>
                      <div className='flex justify-end pt-2'>
                        <Button
                          disabled={buttonDisabled}
                          type='button'
                          className='buttonMain'
                          onClick={() => onSubmit()}
                        >
                          Save
                        </Button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
